import api from '../config/axiosConfig';

/** Envía comentario al ticket (JSON o multipart si hay adjuntos). */
export async function submitTicketComment(
  ticketId: number,
  commentText: string,
  isInternal: boolean,
  files?: File[]
): Promise<void> {
  const hasFiles = Array.isArray(files) && files.length > 0;
  if (hasFiles) {
    const form = new FormData();
    form.append('comment_text', commentText);
    form.append('is_internal', isInternal ? '1' : '0');
    files.forEach((f) => form.append('attachments', f));
    await api.post(`/api/tickets/${ticketId}/comments`, form);
  } else {
    await api.post(`/api/tickets/${ticketId}/comments`, {
      comment_text: commentText,
      is_internal: isInternal,
    });
  }
}
